import React from "react";
import PropTypes from "prop-types";
import TextInfo from "@/bit/components/components.text";
import Button from "@/bit/components/components.button";
import Carousel from "@/bit/components/components.carousel";
import emptyContent from "./emptyContent.json";

const hasTextContent = (textProps) =>
  !!textProps && typeof textProps.text === "string";

const PageSelector = (props) => {
  const {
    cmsHandler,
    "cms-ml-single-selector-list-1": buttonList,
    "cms-ml-single-selector-list-2": subButtonList,
    "cms-atom-text-1": title,
    "cms-atom-text-2": subtitle,
    alias,
    blockName,
    CmsAddElement,
    CmsEditableGroupIcons,
  } = props;
  if (
    (buttonList && !subButtonList) ||
    (!buttonList && subButtonList) ||
    (!buttonList && !subButtonList)
  ) {
    return null;
  }

  // Añadir elemento
  const addElementCmp = (rowIndex, index = "start") =>
    CmsAddElement && (
      <CmsAddElement
        key={`page-selector-add-${rowIndex}-${index}`}
        addProps={{
          index,
          contentId: blockName,
          itemIdDotNotation: `${blockName}.cms-ml-page-selector-1.cms-ml-single-selector-list-${rowIndex}`,
          layout: "horizontal",
          small: true,
        }}
        cmsHandler={cmsHandler}
      />
    );

  return (
    <section className="page-selector hiddenNavigation">
      {[
        [title, buttonList],
        [subtitle, subButtonList],
      ].map((content, parentIndex) => {
        let isEmptyListFlag = false;
        const title = content[0];
        let list = content[1];
        const cdnThereIsTitle = cmsHandler || hasTextContent(title);
        const cdnThereIsList =
          cmsHandler || (list && Array.isArray(list) && list.length > 0);
        if (!cdnThereIsList && !cdnThereIsTitle) {
          return null;
        }

        // Si no hay elementos y estamos en modo edicion mostramos placeholder
        if (list && list.length === 0) {
          list = [{ ...emptyContent, onClick: () => {} }];
          isEmptyListFlag = true;
        }

        return (
          <div
            className="page-selector--column"
            key={`page-selector--section--${parentIndex}`}
          >
            {hasTextContent(title) && (
              <TextInfo {...title} cmsHandler={cmsHandler} />
            )}
            <div className="page-selector--row">
              {cdnThereIsList && (
                <Carousel
                  arrowWidth={cmsHandler ? 30 : 0}
                  arrowRadius={cmsHandler ? 30 : 0}
                  pointRadius={cmsHandler ? 30 : 0}
                  slideSeparation={0}
                  maxPointNum={0}
                  pagination={false}
                  accessibleRole="tablist"
                >
                  {[
                    addElementCmp(parentIndex + 1, "start"),
                    ...list.map((buttonProps, index) => {
                      return (
                        <React.Fragment
                          key={`page-selector-item-${parentIndex}-${index}`}
                        >
                          {/* Bolitas de edicion aqui */}
                          {CmsEditableGroupIcons && (
                            <CmsEditableGroupIcons
                              noCustomLink
                              elementProps={{}}
                              deleteProps={{
                                index,
                                itemIdDotNotation: `${blockName}.cms-ml-page-selector-1.cms-ml-single-selector-list-${
                                  parentIndex + 1
                                }`,
                                alias,
                                frontalListToDelete: list,
                              }}
                              visibleTools={{
                                hiring: false,
                                edit: false,
                                deleteItem: true,
                              }}
                              cmsHandler={!isEmptyListFlag && cmsHandler}
                            />
                          )}
                          <Button
                            {...buttonProps}
                            className="page-selector--row_button"
                            accessibleRole="tab"
                            ariaSelected={buttonProps.type != "collapsed"}
                            cmsHandler={!isEmptyListFlag && cmsHandler}
                            taggingInfo={{
                              componentName: "page-selector",
                              componentVariation: "all",
                              componentContent: buttonProps?.label,
                              componentProduct: buttonProps?.label,
                              eventType: "click",
                            }}
                            cyData={`PageSelector-${index} Button`}
                          />
                        </React.Fragment>
                      );
                    }),
                    addElementCmp(parentIndex + 1, "end"),
                  ].filter(Boolean)}
                </Carousel>
              )}
            </div>
          </div>
        );
      })}
      <style jsx>{`.page-selector {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  // margin-bottom: 1rem;
  .carousel .carousel-window .carousel-item-wrapper {
    padding: 0;
  }
  &--column {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  &--row {
    align-items: center;
    :global(.carousel-item-wrapper) {
      position: relative !important;
    }
    :global(.button-type--collapsed) {
      border: solid 1px #dddddd !important;
    }
    :global(.buttonx) {
      position: relative !important;
      margin-right: 0.5rem;
      margin-top:0.1rem;
    }
  }
}
`}</style>
    </section>
  );
};

PageSelector.propTypes = {
  /**
   * {
   *  "info": "Titulo del selector",
   *  "kind": "both",
   *  "beautifulName": "Título"
   * }
   */
  title: PropTypes.string,
  /**
   * {
   *  "info": "Subitulo del selector",
   *  "kind": "both",
   *  "beautifulName": "Subtítulo"
   * }
   */
  subtitle: PropTypes.string,
  /**
   * {
   *  "info": "Listado principal de selectores",
   *  "kind": "both",
   *  "beautifulName": "Listado principal de selectores"
   * }
   */
  buttonList: PropTypes.arrayOf(PropTypes.object),
  /**
   * {
   *  "info": "Listado secundario de selectores",
   *  "kind": "both",
   *  "beautifulName": "Listado secundario de selectores"
   * }
   */
  subButtonList: PropTypes.arrayOf(PropTypes.object),
};

PageSelector.defaultProps = {
  title: "",
  subtitle: "",
  buttonList: [],
  subButtonList: [],
};

export default PageSelector;
